import type { Player } from '@schibsted-svp/web-player';

export const getPulseTracker = async (player: Player) => {
  return player.getPlugin('PulseStats')?.getTrackerOrNull();
};
